import { CustomListItemId, CustomListKey, IPlacement } from "@sp-crm/core";
import { ActionBarComponent } from "components/shared/action-bar-component";
import { CustomListSelect } from "components/shared/custom-list-select";
import React, { useCallback, useMemo } from "react";
import { useDispatch } from "react-redux";
import { updateClient } from "store/actions";
import { useCustomList } from "store/selectors/bridge";
import { promptForStatusIdChange } from "util/clientStatus";
import { handleEvent } from "util/user-events";

interface ActionBarStatusProps {
    placement: IPlacement;
    reactivate: () => void;
}

export const ActionBarStatus: React.FC<ActionBarStatusProps> = props => {
    const { placement, reactivate } = props;

    const { customList } = useCustomList(CustomListKey.ClientStatus);
    const dispatch = useDispatch();

    const value = useMemo(() => {
        return (
            customList?.items.find(x => x.id === placement.statusListItemId)?.name || ""
        );
    }, [customList, placement]);

    const handleChange = useCallback(
        async (newStatusId: CustomListItemId) => {
            const oldStatusId = placement.statusListItemId;

            const result = await promptForStatusIdChange(
                customList,
                oldStatusId,
                newStatusId,
            );

            if (result === "reactivate") {
                reactivate();
            } else {
                handleEvent("client-status-change", {
                    source: "client-detail-page",
                    oldStatus: oldStatusId,
                    newStatus: newStatusId,
                });
                updateClient(placement.id, "statusListItemId", newStatusId, dispatch);
            }
        },
        [customList, placement, reactivate, dispatch],
    );

    return (
        <ActionBarComponent label="Status" value={value}>
            {({ close }) => {
                return (
                    <CustomListSelect
                        label="Status"
                        customListKey={CustomListKey.ClientStatus}
                        onChange={newStatus => {
                            close();
                            handleChange(newStatus as CustomListItemId);
                        }}
                        value={placement.statusListItemId}
                        valueMode="id"
                    />
                );
            }}
        </ActionBarComponent>
    );
};
